module.exports = __webpack_public_path__ + "media/images/Cup-and-Candle-Zoomed-200-e668901e1a30b78b6a886e439eecdd92.png";